/**
 * subastas-asset.js
 * Main JavaScript asset for NenSons Subastas article page.
 * Load via: {{ 'subastas-asset.js' | asset_url | script_tag }}
 */

(function (global) {
  'use strict';

  /* ─── Shared cleanup after close ─── */
  function doCleanup(modal, img) {
    if (img) {
      img.style.transition = '';
      img.style.transform  = '';
      img.style.opacity    = '';
      img.src              = '';
      img.style.maxHeight  = '';
      img.style.maxWidth   = '';
    }
    if (modal) {
      modal.style.transition = '';
      modal.style.opacity    = '';
      modal.style.display    = 'none';
      modal.classList.remove('mobile-stacked', 'is-dragging');
    }
    var cs = document.getElementById('comments-for-image');
if (cs) { cs.innerHTML = ''; }
var outerCs = document.getElementById('lightbox-comment-section');
if (outerCs) { outerCs.style.height = ''; }
    document.body.classList.remove('modal-open');
    var lp = document.querySelector('.nb-split-left');
    var rp = document.querySelector('.nb-split-right');
    if (lp) { lp.classList.remove('scroll-locked'); lp.style.overflowY = 'auto'; }
    if (rp) { rp.classList.remove('scroll-locked'); rp.style.overflowY = 'auto'; }
    var prev = document.getElementById('lightbox-prev');
    var next = document.getElementById('lightbox-next');
    if (prev) prev.style.display = '';
    if (next) next.style.display = '';
  }

  /* ─── Slide image down then clean up ─── */
  function slideDownAndClose(modal, img) {
    if (!modal || modal.style.display !== 'flex') return;
    /* Slide image off screen */
    if (img) {
      img.style.transition = 'transform 0.35s cubic-bezier(.4,0,.2,1)';
      img.style.transform  = 'translateY(' + window.innerHeight + 'px)';
    }
    /* Fade backdrop */
    modal.style.transition = 'opacity 0.35s ease';
    modal.style.opacity    = '0';
    setTimeout(function () { doCleanup(modal, img); }, 350);
  }

  /* ─── Patch lightbox after template sets it up ─── */
  function patchLightbox() {
    var modal = document.getElementById('lightbox-modal');
    if (!modal) return;

    /* ── 1. Close button ── */
    var closeBtn = document.getElementById('close-lightbox');
    if (closeBtn) {
      var newBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newBtn, closeBtn);
      newBtn.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        slideDownAndClose(modal, document.getElementById('lightbox-image'));
      });
    }

    /* ── 2. Backdrop tap ── */
    modal.addEventListener('click', function (e) {
      if (e.target !== modal) return;
      e.stopImmediatePropagation();
      slideDownAndClose(modal, document.getElementById('lightbox-image'));
    }, true);

    /* ── 3. Drag-to-close (touchstart + touchmove + touchend in capture) ──
       Track startY and lastY ourselves so dy is always accurate on both
       iOS Safari and Android Chrome regardless of how the template tracks it. */
    var CLOSE_THRESHOLD = 110;
    var startY   = 0;
    var lastY    = 0;
    var startX   = 0;
    var tracking = false;
    var locked   = false; /* true = we already took over, suppress template */

    modal.addEventListener('touchstart', function (e) {
      /* Ignore touches inside the comment panel */
      var cs = document.getElementById('lightbox-comment-section') ||
               document.getElementById('comments-for-image');
      if (cs && cs.contains(e.target)) { tracking = false; return; }
      if (e.touches.length !== 1) { tracking = false; return; }
      startY   = e.touches[0].clientY;
      startX   = e.touches[0].clientX;
      lastY    = startY;
      tracking = true;
      locked   = false;
    }, { passive: true, capture: true });

    modal.addEventListener('touchmove', function (e) {
      if (!tracking || e.touches.length !== 1) return;
      lastY = e.touches[0].clientY;
    }, { passive: true, capture: true });

    modal.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;

      var dy = lastY - startY;
      var dx = Math.abs((e.changedTouches[0] ? e.changedTouches[0].clientX : startX) - startX);

      /* Only intercept downward swipes that exceed threshold */
      if (dy < CLOSE_THRESHOLD || dx > Math.abs(dy)) return;

      /* Take over — stop the template's touchend from calling closeLightbox */
      e.stopImmediatePropagation();
      locked = true;

      var img = document.getElementById('lightbox-image');
      slideDownAndClose(modal, img);
    }, { capture: true });

    global.nensonsLightbox = { slideDownAndClose: slideDownAndClose };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(patchLightbox, 700); });
  } else {
    setTimeout(patchLightbox, 700);
  }

})(window);